import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { IcecontrolSettings, IcepanelcontainerSettings, IcepanelSettings, PaymentMethods } from '../../../../icemedx-lib/src/components/models/icesettings';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { expensejournal } from '../../../../icemedx-lib/src/models/accounting/expensejournal';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { servicepaymentreference } from '../../../../icemedx-lib/src/models/accounting/servicepaymentreference';
import { servicedate } from '../../../../icemedx-lib/src/models/ehr/subs/servicedate';
import { servicereference } from '../../../../icemedx-lib/src/models/ehr/subs/servicereference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { AppService } from '../app.service';

const serviceDesc = "Service Description";
const inventoryDesc = "Inventory Item Description";

@Component({
  selector: 'singleservicecharge',
  templateUrl: './singleservicecharge.component.html',
  styleUrls: ['./singleservicecharge.component.scss'],
  providers: [AppService]
})
export class SingleservicechargeComponent implements OnInit {

  @Input() trans_account: string = "";
  @Input() account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  @Input() service: medicalservice = null;
  @Input() caption: string = "Service Charge";
  @Input() listOfServices: any[] = [];
  @Input() listOfInventory: any[] = [];
  @Input() responsibleParties: any[] = [];
  @Input() currentCharges: medicalservice[] = [];
  @Input() currentHistory: chargehistory = new chargehistory(null);

  @Input() panelSync: IcepanelSettings = null;
  @Output() doneClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelClick: EventEmitter<any> = new EventEmitter<any>();
  acctHistoryNone: number = 0;
  acctHistoryJournal: number = 1;
  acctHistoryLedger: number = 2;
  acctHistoryClaims: number = 3;
  acctHistoryPayments: number = 4;

  serviceChargeFormGrp: FormGroup = null;

  chargeType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ChargeType", "Type of Charge")
    .setControlName("ChargeType")
    .createFormControl(this.getChargeType(), [Validators.required]);

  chargeStatus: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ChargeStatus", "Status of Item")
    .setControlName("ChargeStatus")
    .createFormControl(IceTypes.trans_status.isNone, [Validators.required])
    .setOptions(MessageService.getAccountItemStatues());

  fromDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", width: "125px" }, null, null, "FromDate")
    .setControlName("FromDate")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);
  toDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", width: "125px" }, null, null, "ToDate")
    .setControlName("ToDate")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);

  codeCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Code", "Code")
    .setControlName("Code")
    .createFormControl("", []);

  serviceDescCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "ServiceDesc", serviceDesc)
    .setControlName("ServiceDesc")
    .createFormControl("", [Validators.required]);

  copayDescCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "CoPayDesc", "Select Service")
    .setControlName("CoPayDesc")
    .createFormControl("", [Validators.required]);

  quantity: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%", inputType: "number" }, null, null, "Quantity", "Quantity")
  .setControlName("Quantity")
  .createFormControl(0.0, []);

  unitPrice: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Price", "Price")
    .setControlName("Price")
    .createFormControl(0.0, []);

  totalAmount: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "TotalAmount", "Total Amount")
    .setControlName("TotalAmount")
    .createFormControl(0.0, [])
    .setReadonly(true);

  amountDue: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", color: "red" }, null, null, "AmountDue", "Amt. Due")
    .setControlName("AmountDue")
    .createFormControl(0.0, [])
    .setReadonly(true);

  amountPaid: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%", color: "red" }, null, null, "Paid", "Pay Amount")
    .setControlName("Paid")
    .createFormControl(0.0, []);

  types = [
    { value: IceTypes.coa_types.coaCoPayIncome, name: "Co-Pay" },
    { value: IceTypes.coa_types.coaServiceIncome, name: "Service" },
    { value: IceTypes.coa_types.coaOtherIncome, name: "Other Item" },
  ];

  applyChargeForService: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [{ name: "00703565301 - Toposar 20 MG/ML Injectable Solution", value: "" }], width: "100%" }, null, null, "ApplyChargeFor", "Apply Co-Pay For")
    .setControlName("ApplyChargeFor")
    .createFormControl(0, [Validators.required]);

  responsibleParty: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ResponsibleParty", "Responsible Party")
    .setControlName("ResponsibleParty")
    .createFormControl(0, []);

  billingSummary: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", height: "100px" }, null, null, "BillingSummary", "Responsible Party Summary")
    .setControlName("BillingSummary")
    .createFormControl("", []);

  notesCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", height: "200px" }, null, null, "Notes", "Notes")
    .setControlName("Notes")
    .createFormControl("", []);

  doneItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Done", glyphClass: "fa-plus-circle" }, null, null, "doneItem");
  cancelItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Cancel", glyphClass: "fa-plus-circle" }, null, null, "cancelItem");
  addNewItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Add Another Item", glyphClass: "fa-plus-circle" }, null, null, "addItem");

  historyTypes = [
    { value: this.acctHistoryNone, name: "" },
    { value: this.acctHistoryJournal, name: "Journal" },
    { value: this.acctHistoryLedger, name: "Ledger" },
    { value: this.acctHistoryClaims, name: "Claims" },
    { value: this.acctHistoryPayments, name: "Payments and Adjustments" },
  ];

  historyTypeCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "50%" }, null, null, "historyType", "Accounting History")
    .setControlName("historyType")
    .createFormControl("", [])
    .setOptions(this.historyTypes);

  selectedHistory: number = this.acctHistoryNone;
  journalList: any[] = [];
  ledgerList: any[] = [];
  postingList: any[] = [];

  postDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "Date of Post", width: "125px" }, null, null, "PostDate")
    .setControlName("PostDate")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);;

  copayAdjTypes = [
    { value: IceTypes.coa_types.coaCoPayAR, name: "Co-Pay Payment" },
    { value: IceTypes.coa_types.coaDiscount, name: "Discount" },
    { value: IceTypes.coa_types.coaClaimAdjustment, name: "Claim Adjuments" },
    { value: IceTypes.coa_types.coaDisallowedAdjustment, name: "Disallowed Adjustment" },
    { value: IceTypes.coa_types.coaContractualObligationsAdjustment, name: "Contractual Obligations Adjustment" },
    { value: IceTypes.coa_types.coaCorrectionandReversalsAdjustment, name: "Correction / Reversals Adjustment" },
  ];

  payAdjTypes = [
    { value: IceTypes.coa_types.coaAR, name: "Service Payment" },
    { value: IceTypes.coa_types.coaCoInsuranceAR, name: "Co-Insurance Payment" },
    { value: IceTypes.coa_types.coaDeductibleAR, name: "Deductible Payment" },
    { value: IceTypes.coa_types.coaDiscount, name: "Discount" },
    { value: IceTypes.coa_types.coaClaimAdjustment, name: "Claim Adjuments" },
    { value: IceTypes.coa_types.coaDisallowedAdjustment, name: "Disallowed Adjustment" },
    { value: IceTypes.coa_types.coaContractualObligationsAdjustment, name: "Contractual Obligations Adjustment" },
    { value: IceTypes.coa_types.coaCorrectionandReversalsAdjustment, name: "Correction / Reversals Adjustment" },
  ];

  postChargeType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostChargeType", "Pay/Adj. Type")
    .setControlName("PostChargeType")
    .createFormControl(IceTypes.coa_types.coaAR, [Validators.required])
    .setOptions(this.payAdjTypes);

  postNotesCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", height: "200px" }, null, null, "PostNotes", "Notes")
    .setControlName("PostNotes")
    .createFormControl("", []);

  postRefCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "PostRef", "Ref. Info.")
    .setControlName("PostRef")
    .createFormControl("", []);

  postResponsibleParty: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostResponsibleParty", "Responsible Party")
    .setControlName("PostResponsibleParty")
    .createFormControl(0, []);

  postAmount: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Paid", "Post Amount")
    .setControlName("PostAmount")
    .createFormControl(0.0, []);

  postCashAccount: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostCashAccount", "Cash Account")
    .setControlName("PostCashAccount")
    .createFormControl(IceTypes.coa_types.coaCashPrimary, [Validators.required])
    .setOptions([
      { value: IceTypes.coa_types.coaCashPetty, name: AccountingService.getCoaType(IceTypes.coa_types.coaCashPetty) },
      { value: IceTypes.coa_types.coaCashPrimary, name: AccountingService.getCoaType(IceTypes.coa_types.coaCashPrimary) },
      { value: IceTypes.coa_types.coaCashSecondary, name: AccountingService.getCoaType(IceTypes.coa_types.coaCashSecondary) },
    ]);

  postPayType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostPayType", "Pay Type")
    .setControlName("PostPayType")
    .createFormControl(PaymentMethods.pmCash, [Validators.required])
    .setOptions([
      { value: PaymentMethods.pmNone, name: "N/A" },
      //{ value: PaymentMethods.pmCreditCard, name: "Credit Card" },
      //{ value: PaymentMethods.pmBankAccount, name: "Check" },
      { value: PaymentMethods.pmCash, name: "Cash" },
    ]);

  postButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Post", glyphClass: "fa-plus-circle" }, null, null, "PostButton");


  constructor(private appSvc: AppService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private medCodeSvc: MedicalcodesService) {
  }

  initializeControls(): void {
    this.chargeType.getFormControl().setValue(this.getChargeType());
    this.chargeTypeChanged(this.getChargeType());
    this.responsibleParty.setOptions(this.responsibleParties);
    if (this.service == null) return;

    this.chargeStatus.getFormControl().setValue(Iceutility.toLong(this.service.trans_status));

    let dtFrom: any = null;
    let dtTo: any = null;

    if (this.service.SVCDTS != null && this.service.SVCDTS.length > 0) {
      dtFrom = Iceutility.isTextDateTime(this.service.SVCDTS[0].date_required) ? Iceutility.GetLocalDate(this.service.SVCDTS[0].date_required) : Iceutility.ConvertFromDotNetServerTime(this.service.SVCDTS[0].date_required);
      dtTo = Iceutility.isTextDateTime(this.service.SVCDTS[0].end_date_required) ? Iceutility.GetLocalDate(this.service.SVCDTS[0].end_date_required) : Iceutility.ConvertFromDotNetServerTime(this.service.SVCDTS[0].end_date_required);
    }

    this.fromDateCtrl.getFormControl().setValue(dtFrom);
    this.toDateCtrl.getFormControl().setValue(dtTo);
    this.codeCtrl.getFormControl().setValue(this.service.code);
    if (this.service.service_description.length > 0) {
      let svcDesc = [{ name: this.service.service_description, value: this.service.code }];
      this.serviceDescCtrl.getFormControl().setValue(JSON.stringify(svcDesc));
    }
    else {
      this.serviceDescCtrl.getFormControl().setValue("");
    }
    this.quantity.getFormControl().setValue(Iceutility.toDouble(this.service.quantity));
    this.unitPrice.getFormControl().setValue(Iceutility.toDouble(this.service.price));
    this.totalAmount.getFormControl().setValue(Iceutility.toDouble(this.service.total_amount));
    let amtDue = Iceutility.toDouble(this.service.total_amount);
    debugger;
    let histSvc = this.currentHistory.getService(this.service.medical_service_key);
    if (histSvc != null) {
      amtDue = Iceutility.toDouble(this.currentHistory.getServiceAmountDue(this.service.medical_service_key));
      this.amountDue.getFormControl().setValue(amtDue);
    }
    else {
      this.amountDue.getFormControl().setValue(amtDue);
    }
    this.amountDue.properties.color = amtDue > 0 ? "red" : "green";
    this.notesCtrl.getFormControl().setValue(this.service.additional_note);

    this.copayDescCtrl.getFormControl().setValue(this.service.copay_service_key + "|" + this.service.code);
    this.responsibleParty.getFormControl().setValue(AccountingService.getPartyBucketKey(this.service));
    setTimeout(() => {
      this.serviceDescCtrl.setMultipleSelection(false);
    });

    this.selectedHistory = this.acctHistoryNone;
    this.historyTypeCtrl.getFormControl().setValue(this.selectedHistory);
    this.historyTypeChanged(this.selectedHistory);

    // setup the posting fields
    this.postResponsibleParty.setOptions(this.responsibleParties);

    this.resetPostingControls();

    if (!this.showAddNewItem()) {
      this.chargeType.setDisabled(true);
    }
    this.setControlEditing(amtDue == Iceutility.toDouble(this.service.total_amount));
  }

  reSubscribeToInitialize(): void {
    if (this.panelSync != null
      && (this.panelSync.initializeEvent == null
        || this.panelSync.initializeEvent.observers.length == 0)) {
      this.panelSync.createInitializeEvent().subscribe(
        event => {
          this.initializeControls();
        },
        error => {
        }
      );
    }
  }

  ngOnInit() {
    if (this.panelSync != null) {
      this.panelSync.createInitializeEvent().subscribe(
        event => {
          this.initializeControls();
        },
        error => {
        }
      );
    }
    this.chargeType.setOptions(this.types);
    this.chargeStatus.setOptions(MessageService.getAccountItemStatues());
    this.chargeTypeChanged(this.getChargeType());
    this.responsibleParty.setOptions(this.responsibleParties);
  }

  getChargeType(): IceTypes.coa_types {
    if (this.service == null) return IceTypes.coa_types.coaServiceIncome;

    return Iceutility.toLong(this.service.inc_coa_type);
  }

  isCoPay(): boolean {
    return this.service.inc_coa_type == IceTypes.coa_types.coaCoPayIncome;
  }

  isReadyOnly(): boolean {
    return Iceutility.toLong(this.service.trans_status) != IceTypes.trans_status.isNone;
  }

  resetCalculations() {
    this.quantity.getFormControl().setValue(0.0);
    this.unitPrice.getFormControl().setValue(0.0);
    this.totalAmount.getFormControl().setValue(0.0);
  }

  resetTypeDescriptions(resetCode: boolean) {
    this.serviceDescCtrl.getFormControl().setValue("");
    this.copayDescCtrl.getFormControl().setValue("");

    if (resetCode) this.codeCtrl.getFormControl().setValue("");
  }

  resetPostingControls(): void {
    let defPostType = IceTypes.coa_types.coaAR;
    switch (this.getChargeType()) {
      case IceTypes.coa_types.coaServiceIncome:
      case IceTypes.coa_types.coaOtherIncome:
        {
          defPostType = IceTypes.coa_types.coaAR;
          this.postChargeType.setOptions(this.payAdjTypes);
          break;
        }
      case IceTypes.coa_types.coaCoPayIncome:
        {
          defPostType = IceTypes.coa_types.coaCoPayAR;
          this.postChargeType.setOptions(this.copayAdjTypes);
          break;
        }
    }

    this.postChargeType.getFormControl().setValue(defPostType);
    this.postResponsibleParty.getFormControl().setValue(AccountingService.getPartyBucketKey(this.service));
    this.postPayType.getFormControl().setValue(PaymentMethods.pmCash);
    this.postCashAccount.getFormControl().setValue(IceTypes.coa_types.coaCashPrimary);
    this.postDateCtrl.getFormControl().setValue(Iceutility.GetLocalDate());
    this.postNotesCtrl.getFormControl().setValue("");
    this.postRefCtrl.getFormControl().setValue("");
    this.postAmount.getFormControl().setValue(0);

    this.postPayType.setDisabled(false);
    this.postCashAccount.setDisabled(false);
  }

  setControlEditing(allowPriceChange: boolean): void {
    let readonly = this.isReadyOnly();
    this.fromDateCtrl.setReadonly(readonly);
    this.toDateCtrl.setReadonly(readonly);
    this.responsibleParty.setDisabled(readonly);
    this.codeCtrl.setReadonly(readonly);

    if (allowPriceChange) {
      this.quantity.setReadonly(readonly);
      this.unitPrice.setReadonly(readonly);
    }
    else {
      this.quantity.setReadonly(true); // don't allow if payments or adjustment are made
      this.unitPrice.setReadonly(true);
    }
    this.totalAmount.setReadonly(true); // always RO
    this.amountDue.setReadonly(true); // always RO
    this.notesCtrl.setReadonly(readonly);
    this.copayDescCtrl.setReadonly(readonly);
    this.serviceDescCtrl.setReadonly(readonly);

    // posting
    this.postChargeType.setDisabled(readonly);
    this.postResponsibleParty.setDisabled(readonly);
    this.postPayType.setDisabled(readonly);
    this.postCashAccount.setDisabled(readonly);
    this.postDateCtrl.setReadonly(readonly);
    this.postNotesCtrl.setReadonly(readonly);
    this.postRefCtrl.setReadonly(readonly);
    this.postAmount.setReadonly(readonly);
  }

  showAddNewItem(): boolean {
    return this.service.medical_service_key.length == 0;
  }

  /////////////////////////////////////////////
  // Events
  typeSelectChange(event): void {
    this.service.inc_coa_type = <IceTypes.coa_types>event.value;
    this.chargeTypeChanged(this.getChargeType());
  }

  statusSelectChange(event): void {
    this.service.trans_status = event.value;
    let amtDue = this.amountDue.getFormControl().value;
    this.setControlEditing(amtDue == Iceutility.toDouble(this.service.total_amount));
  }

  historySelectChange(event): void {
    this.selectedHistory = event.value;
    this.historyTypeChanged(this.selectedHistory);
  }

  serviceDescChange(event): void {
    if (event.autocompleteRemoveSettings != null) {
      this.resetCalculations();
    }

    let svcDescCtrl: IcecontrolSettings = <IcecontrolSettings>event.autocompleteSettings;
    let selected = null;
    try {
      selected = JSON.parse(svcDescCtrl.getFormControl().value);
      if (selected != null && selected.length > 0)
        selected = selected[0]
      else
        throw "Unable to parse service selected";
    }
    catch (e) {
      console.log(e);
      return;
    }

    let chrgeType = this.getChargeType();
    let thisList = null;
    if (chrgeType == IceTypes.coa_types.coaServiceIncome) {
      thisList = this.listOfServices;
    }
    else if (chrgeType == IceTypes.coa_types.coaOtherIncome) {
      thisList = this.listOfInventory;
    }
    else {
      return;
    }

    let svcs = thisList.filter(s => s.code == selected.value);
    if (svcs.length > 0) {
      let qty = 1.0;
      this.quantity.getFormControl().setValue(qty);
      let price = Iceutility.toDouble(svcs[0].price);
      this.unitPrice.getFormControl().setValue(price);
      let total = price * qty;
      this.totalAmount.getFormControl().setValue(total);

      this.codeCtrl.getFormControl().setValue(svcs[0].code);
    }
  }

  copayDescChange(event): void {
    let copaySvcKey = event.value;
    let optFound = this.copayDescCtrl.getOptions().filter(o => o.value == copaySvcKey);
    if (optFound.length > 0) {
      let parts = optFound[0].value.split("|");
      this.codeCtrl.getFormControl().setValue(parts[1]);
    }
  }

  chargeTypeChanged(ct: IceTypes.coa_types): void {
    switch (ct) {
      case IceTypes.coa_types.coaServiceIncome:
      case IceTypes.coa_types.coaOtherIncome: {
        this.serviceDescCtrl.setOptions(IceTypes.coa_types.coaServiceIncome == ct ? this.listOfServices : this.listOfInventory);
        this.serviceDescCtrl.placeholder = serviceDesc;
        break;
      }
      case IceTypes.coa_types.coaCoPayIncome: { 
        if (this.currentCharges != null && this.copayDescCtrl.getOptions().length == 0) {
          let opts = [];
          for (let ichrg = 0; ichrg < this.currentCharges.length; ichrg++) {
            let chrg = this.currentCharges[ichrg];
            // Don't show copays
            if (Iceutility.toLong(chrg.inc_coa_type) == IceTypes.coa_types.coaCoPayIncome)
              continue;

            let dtFrom = Iceutility.isTextDateTime(chrg.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(chrg.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(chrg.SVCDTS[0].date_required), null, false);
            let dtTo = Iceutility.isTextDateTime(chrg.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(chrg.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(chrg.SVCDTS[0].end_date_required), null, false);
            let desc = chrg.service_description;
            if (dtFrom != null && dtFrom.length > 0)
              desc += " From: " + dtFrom;

            if (dtTo != null && dtTo.length > 0)
              desc += " To: " + dtTo;

            opts.push({ name: desc, value: chrg.medical_service_key + "|" + chrg.code });
          }
          this.copayDescCtrl.setOptions(opts);
        }
        break;
      }
      default: {
        this.serviceDescCtrl.setOptions(this.listOfInventory);
        this.serviceDescCtrl.placeholder = inventoryDesc;
        break;
      }
    }

    this.resetTypeDescriptions(true);
    this.resetCalculations();
  }

  historyTypeChanged(selHistory: number) {
    this.journalList = [];
    this.ledgerList = [];
    this.postingList = [];
    debugger;
    switch (selHistory) {
      case this.acctHistoryJournal: {
        let jrnldata = this.currentHistory.getServiceIncomes(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: incomerevenuejournal = <incomerevenuejournal>jrnldata[irec];
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          let entry = {
            journal_key: rec.income_revenue_journal_key,
            medical_service_key: rec.medical_service_key,
            origical_date: rec.journal_date,
            journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            coa_type: AccountingService.getCoaType(rec.coa_type),
            journal_desc: rec.journal_desc,
            journal_note: rec.journal_note,
            journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
            otherifo: "",
            debit: debit,
            credit: credit,
          };
          this.journalList.push(entry);
        }

        jrnldata = this.currentHistory.getServiceAssets(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: assetjournal = <assetjournal>jrnldata[irec];
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          let entry = {
            journal_key: rec.asset_journal_key,
            medical_service_key: rec.medical_service_key,
            origical_date: rec.journal_date,
            journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            coa_type: AccountingService.getCoaType(rec.coa_type),
            journal_desc: rec.journal_desc,
            journal_note: rec.journal_note,
            journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
            otherifo: "",
            debit: debit,
            credit: credit,
          };
          this.journalList.push(entry);
        }

        jrnldata = this.currentHistory.getServiceExpenses(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: expensejournal = <expensejournal>jrnldata[irec];
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          let entry = {
            journal_key: rec.expense_journal_key,
            medical_service_key: rec.medical_service_key,
            origical_date: rec.journal_date,
            journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            coa_type: AccountingService.getCoaType(rec.coa_type),
            journal_desc: rec.journal_desc,
            journal_note: "",
            journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
            otherifo: "",
            debit: debit,
            credit: credit,
          };
          this.journalList.push(entry);
        }

        this.journalList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });
        break;
      }
      case this.acctHistoryLedger: {
        let balance = 0.0;
        let jrnldata = this.currentHistory.getServiceAssets(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: assetjournal = <assetjournal>jrnldata[irec];
          let charge = Iceutility.toDouble(rec.debit);

          let ctyp = Iceutility.toLong(rec.coa_type);
          let srcTyp = Iceutility.toLong(rec.src_type);
          if (IceTypes.coa_types.coaAR == ctyp
            && (IceTypes.SourceType.srcService == srcTyp
              || IceTypes.SourceType.srcUndefined == srcTyp)) {

            balance += charge;
            let descSuffix = "Service";
            let entry = {
              journal_key: rec.asset_journal_key,
              medical_service_key: rec.medical_service_key,
              origical_date: rec.journal_date,
              date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
              trans_account: rec.trans_account,
              account_type: Iceutility.toLong(rec.account_type),
              coa_type: AccountingService.getCoaType(rec.coa_type),
              desc: rec.journal_desc + " - " + descSuffix,
              note: rec.journal_note,
              code: rec["journal_code"] != null ? rec["journal_code"] : "",
              otherifo: "",
              charge: charge,
              credit: "",
              balance: balance
            };
            this.ledgerList.push(entry);
          }
        }

        let postdata = this.currentHistory.getAllServicePostings(this.service.medical_service_key);
        for (const postkey in postdata) {
          let thispost: payment = postdata[postkey];
          for (let iref = 0; thispost != null && iref < thispost.SERVICES.length; iref++) {
            let rec: servicepaymentreference = thispost.SERVICES[iref];
            let respName = "", respKey = AccountingService.getPartyBucketKeyEx(rec.subscriber_key, rec.coverage_key, rec.payer_key);
            let foundResp = this.responsibleParties.filter(r => r.value == respKey);
            if (foundResp.length > 0)
              respName = foundResp[0].name;
            else
              respName = "Unknown";

            let descSuffix = "Service";
            let ctyp = Iceutility.toLong(rec.coa_type);
            switch (ctyp) {
              case IceTypes.coa_types.coaAR: {
                descSuffix = "Payment";
                break;
              }
              case IceTypes.coa_types.coaCoPayAR: {
                descSuffix = "Co-Payment";
                break;
              }
              case IceTypes.coa_types.coaCoInsuranceAR: {
                descSuffix = "Co-Insurance Payment";
                break;
              }
              case IceTypes.coa_types.coaDeductibleAR: {
                descSuffix = "Deductible Payment";
                break;
              }
              case IceTypes.coa_types.coaDiscount:
              case IceTypes.coa_types.coaClaimAdjustment:
              case IceTypes.coa_types.coaDisallowedAdjustment:
              case IceTypes.coa_types.coaContractualObligationsAdjustment:
              case IceTypes.coa_types.coaCorrectionandReversalsAdjustment: {
                let foundAdj = this.payAdjTypes.filter(x => x.value == ctyp);
                if (foundAdj.length > 0) {
                  descSuffix = foundAdj[0].name;
                }
                else {
                  descSuffix = "Adjustment";
                }
                break;
              }
            }

            let credit = Iceutility.toDouble(rec.amount);
            balance -= credit;

            let entry = {
              journal_key: "",
              service_reference_key: rec.service_reference_key,
              medical_service_key: rec.medical_service_key,
              origical_date: thispost.pay_date,
              date: Iceutility.getDateTextEx(Iceutility.isTextDateTime(thispost.pay_date) ? thispost.pay_date : Iceutility.ConvertFromDotNetServerTime(thispost.pay_date)),
              trans_account: thispost.trans_account,
              account_type: Iceutility.toLong(thispost.account_type),
              coa_type: AccountingService.getCoaType(rec.coa_type),
              desc: rec.description + " - " + descSuffix + " - " + respName,
              note: "",
              code: "",
              otherifo: respName,
              charge: "",
              credit: -1.0 * credit,
              balance: balance
            };
            this.ledgerList.push(entry);
          }
        }

        //this.ledgerList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });
        break;
      }
      case this.acctHistoryPayments: {
        let postdata = this.currentHistory.getAllServicePostings(this.service.medical_service_key);
        for (const postkey in postdata) {
          let thispost: payment = postdata[postkey];
          for (let iref = 0; thispost != null && iref < thispost.SERVICES.length; iref++) {
            let rec: servicepaymentreference = thispost.SERVICES[iref];
            let respName = "", respKey = AccountingService.getPartyBucketKeyEx(rec.subscriber_key, rec.coverage_key, rec.payer_key);
            let foundResp = this.responsibleParties.filter(r => r.value == respKey);
            if (foundResp.length > 0)
              respName = foundResp[0].name;
            else
              respName = "Unknown";

            let payAdjTyp = "";
            let payAdjTypFound = this.payAdjTypes.filter(p => p.value == Iceutility.toLong(rec.coa_type));
            if (payAdjTypFound.length > 0)
              payAdjTyp = payAdjTypFound[0].name;
            else
              payAdjTyp = AccountingService.getCoaType(rec.coa_type);

            let payType = "N/A";
            if (thispost.payment_response === PaymentMethods.pmCash.toString()) {
              payType = "Cash";
            }
            let entry = {
              payment_key: thispost.payment_key,
              service_reference_key: rec.service_reference_key,
              medical_service_key: rec.medical_service_key,
              pay_date: Iceutility.getDateTextEx(Iceutility.isTextDateTime(thispost.pay_date) ? thispost.pay_date : Iceutility.ConvertFromDotNetServerTime(thispost.pay_date)),
              origical_date: thispost.pay_date,
              trans_account: thispost.trans_account,
              account_type: Iceutility.toLong(thispost.account_type),
              responsibleParty: respName,
              coa_type: payAdjTyp,
              description: rec.description,
              amount: Iceutility.toDouble(rec.amount),
              payref: thispost.reference_num,
              paytype: payType,
              cash_coa_type: Iceutility.toLong(thispost.cash_coa_type) == IceTypes.coa_types.coaNone ? "N/A" : AccountingService.getCoaType(thispost.cash_coa_type),
            };
            this.postingList.push(entry);
          }
        }

        this.postingList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });
        break;
      }
    }
  }

  codeChange(event, chrgeType: IceTypes.coa_types, codeCtrl: IcecontrolSettings) {
    let thisList = null;
    if (chrgeType == IceTypes.coa_types.coaServiceIncome) {
      thisList = this.listOfServices;
    }
    else if (chrgeType == IceTypes.coa_types.coaOtherIncome) {
      thisList = this.listOfInventory;
    }
    else {
      this.resetTypeDescriptions(false);
      this.resetCalculations();
      return;
    }

    let svcs = thisList.filter(s => s.code == codeCtrl.getFormControl().value);
    if (svcs.length > 0) {
      let selected = [{ name: svcs[0].name, value: svcs[0].code }];

      this.serviceDescCtrl.getFormControl().setValue(JSON.stringify(selected));
      let qty = 1.0;
      this.quantity.getFormControl().setValue(qty);
      let price = Iceutility.toDouble(svcs[0].price);
      this.unitPrice.getFormControl().setValue(price);
      let total = price * qty;
      this.totalAmount.getFormControl().setValue(total);
    }
    else {
      this.resetTypeDescriptions(false);
      this.resetCalculations();
    }
  }

  codeEntered(event) {
    if (event.keydownEnterSettings == null) return;

    let codeCtrl: IcecontrolSettings = <IcecontrolSettings>event.keydownEnterSettings;
    this.codeChange(event, this.getChargeType(), codeCtrl);
  }

  codeTab(event) {
    if (event.keydownTabSettings == null) return;

    let codeCtrl: IcecontrolSettings = <IcecontrolSettings>event.keydownTabSettings;
    this.codeChange(event, this.getChargeType(), codeCtrl);
  }

  quantityKeyUp(event) {
    let newQty = Iceutility.toDouble(this.quantity.getFormControl().value);
    let price = Iceutility.toDouble(this.unitPrice.getFormControl().value);
    let total = price * newQty;
    this.totalAmount.getFormControl().setValue(total);
    this.quantity.getFormControl().setValue(newQty);
  }

  priceKeyUp(event) {
    let qty = Iceutility.toDouble(this.quantity.getFormControl().value);
    let newPrice = Iceutility.toDouble(this.unitPrice.getFormControl().value);
    let total = newPrice * qty;
    this.totalAmount.getFormControl().setValue(total);
    this.unitPrice.getFormControl().setValue(newPrice);
  }

  quantityChanged(event) {
    let newQty = Iceutility.toDouble(event.currentTarget.value);
    let price = Iceutility.toDouble(this.unitPrice.getFormControl().value);
    let total = price * newQty;
    this.totalAmount.getFormControl().setValue(total);
  }

  amountPaidKeyUp(event) {
    let amtPaid = Iceutility.toDouble(this.amountPaid.getFormControl().value);
    this.amountPaid.getFormControl().setValue(amtPaid);
  }

  responsiblePartySelectChange(event): void {
    let thisPartyBucketKey = event.value;
    let optFound = this.responsibleParty.getOptions().filter(o => o.value == thisPartyBucketKey);

    this.billingSummary.getFormControl().setValue("");
    if (optFound.length > 0) {
      this.billingSummary.getFormControl().setValue(optFound[0].summary.join("<br>"));
    }
  }

  postChargeTypeChange(event) {
    if (event.value == IceTypes.coa_types.coaAR
      || event.value == IceTypes.coa_types.coaCoInsuranceAR
      || event.value == IceTypes.coa_types.coaCoPayAR
      || event.value == IceTypes.coa_types.coaDeductibleAR) {
      this.postPayType.setDisabled(false);
      this.postCashAccount.setDisabled(false);
    }
    else {
      this.postPayType.setDisabled(true);
      this.postCashAccount.setDisabled(true);
    }
  }

  postAmountKeyUp(event) {
    let postAmt = Iceutility.toDouble(this.postAmount.getFormControl().value);
    this.postAmount.getFormControl().setValue(postAmt);
  }

  postItemClick(event) {
    if (this.isReadyOnly()) return;

    // To do make date and amount required
    // don't allow editing if payments have been made
    // new post should be allowed to be edited
    let respKey = this.postResponsibleParty.getFormControl().value;
    let respName = "";
    let foundResp = this.responsibleParties.filter(r => r.value == respKey);
    if (foundResp.length > 0)
      respName = foundResp[0].name;
    else
      respName = "Unknown";

    let payAdjTypeName = "";
    let payAdjTyp = this.postChargeType.getFormControl().value;
    let payAdjTypFound = this.payAdjTypes.filter(p => p.value == Iceutility.toLong(payAdjTyp));
    if (payAdjTypFound.length > 0)
      payAdjTypeName = payAdjTypFound[0].name;
    else
      payAdjTypeName = AccountingService.getCoaType(payAdjTyp);

    let payDate = this.postDateCtrl.getFormControl().value;
    let postNote = this.postNotesCtrl.getFormControl().value;
    let refInfo = this.postRefCtrl.getFormControl().value;
    let amt = this.postAmount.getFormControl().value;
    let payType = this.postPayType.getFormControl().value;
    let cashCoa = this.postCashAccount.getFormControl().value;

    if (payAdjTyp != IceTypes.coa_types.coaAR
      && payAdjTyp != IceTypes.coa_types.coaCoInsuranceAR
      && payAdjTyp != IceTypes.coa_types.coaCoPayAR
      && payAdjTyp != IceTypes.coa_types.coaDeductibleAR) {
      payType = PaymentMethods.pmNone;
      cashCoa = IceTypes.coa_types.coaNone;
    }

    let post: payment = new payment();
    debugger;
    let allposting = this.currentHistory.getAllServicePostings(this.service.medical_service_key);
    if (allposting == null) {
      allposting = {};
      this.currentHistory.setAllServicePostings(this.service.medical_service_key, allposting);
    }

    post.payment_key = Iceutility.guid(true);
    post.pay_date = Iceutility.convertToUTCEx(payDate);
    post.account_type = Iceutility.toLong(this.service.account_type);
    post.trans_account = this.service.trans_account
    post.cash_coa_type = cashCoa;
    post.reference_num = refInfo;
    post.payment_response = payType == NaN ? "" : payType;
    post.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

    let svcpost: servicepaymentreference = new servicepaymentreference();
    svcpost.amount = amt;
    svcpost.coa_type = payAdjTyp;
    svcpost.description = postNote.length == 0 ? this.service.service_description : postNote;

    svcpost.service_reference_key = Iceutility.guid(false);
    svcpost.medical_service_key = this.service.medical_service_key;
    svcpost.other_items_key = this.service.other_items_key;
    svcpost.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    AccountingService.setPaymentSubscriberFromDDLKey(this.postResponsibleParty, svcpost);
    post.SERVICES.push(svcpost);

    allposting[post.payment_key] = post;

    let entry = {
      payment_key: post.payment_key,
      service_reference_key: Iceutility.guid(false),
      medical_service_key: this.service.medical_service_key,
      pay_date: Iceutility.getDateTextEx(payDate),
      origical_date: "",
      trans_account: this.service.trans_account,
      account_type: Iceutility.toLong(this.service.account_type),
      responsibleParty: respName,
      coa_type: payAdjTypeName,
      description: svcpost.description,
      amount: Iceutility.toDouble(amt),
      payref: refInfo,
      paytype: payType == PaymentMethods.pmNone ? "N/A" : "Cash",
      cash_coa_type: cashCoa == IceTypes.coa_types.coaNone ? "N/A" : AccountingService.getCoaType(cashCoa),
    };
    this.postingList.push(entry);
    this.postingList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });

    this.resetPostingControls();

    // To track posting here, then if cancel is issued we can remove the new posting from allposting
  }

  addNewItemClick(event): void {
  }

  cancelItemClick(event): void {
    this.cancelClick.emit();
    this.service = null;
    this.reSubscribeToInitialize();
  }

  doneItemClick(event): void {
    let type = this.chargeType.getFormControl().value;
    let status = this.chargeStatus.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let code = this.codeCtrl.getFormControl().value;
    let svcDesc = this.serviceDescCtrl.getFormControl().value;
    let copaySvcKey = this.copayDescCtrl.getFormControl().value;
    let qty = this.quantity.getFormControl().value;
    let price = this.unitPrice.getFormControl().value;
    let total = this.totalAmount.getFormControl().value;
    let paid = this.amountPaid.getFormControl().value;
    let ntes = this.notesCtrl.getFormControl().value;
    // To do validation

    this.service.inc_coa_type = <IceTypes.coa_types>type;
    this.service.trans_status = <IceTypes.trans_status>status;
    if (this.service.inc_coa_type == IceTypes.coa_types.coaServiceIncome
      || this.service.inc_coa_type == IceTypes.coa_types.coaOtherIncome) {
      let obj = null;
      try {
        obj = JSON.parse(svcDesc);
        if (obj != null && obj.length > 0) {
          this.service.service_description = obj[0].name;
          this.service.code = obj[0].value;
          if (this.service.inc_coa_type == IceTypes.coa_types.coaOtherIncome) {
            let invFound = this.serviceDescCtrl.getOptions().filter(o => o.value == obj[0].value);
            if (invFound.length > 0) {
              this.service.other_items_key = invFound[0].key;
            }
          }
        }
      }
      catch (e) {
      }
    }
    else {
      let optFound = this.copayDescCtrl.getOptions().filter(o => o.value == copaySvcKey);
      if (optFound.length > 0) {
        this.service.service_description = optFound[0].name;
        let parts = optFound[0].value.split("|");
        this.service.copay_service_key = parts[0];
        this.service.code = parts[1];
      }
    }
    this.service.quantity = qty
    this.service.price = price;
    this.service.total_amount = total;
    this.service.additional_note = ntes;
    AccountingService.setServiceSubscriberFromDDLKey(this.responsibleParty, this.service);
    let svcdts = null;
    let foundDt = this.service.SVCDTS.filter(sdt => sdt.datetime_qualifier == "472");
    if (foundDt.length == 0) {
      svcdts = new servicedate();
      this.service.SVCDTS.push(svcdts);
    }
    else {
      svcdts = foundDt[0];
    }
    svcdts.date_required = Iceutility.convertToUTCEx(fromDt);
    svcdts.end_date_required = Iceutility.convertToUTCEx(toDt);

    event.paid = paid;

    this.doneClick.emit(event);
    this.service = null;
  }
}
